import { render, staticRenderFns } from "./RestaurantPOS2.vue?vue&type=template&id=4aa93d8e&scoped=true"
import script from "./RestaurantPOS2.vue?vue&type=script&lang=js"
export * from "./RestaurantPOS2.vue?vue&type=script&lang=js"
import style0 from "./RestaurantPOS2.vue?vue&type=style&index=0&id=4aa93d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa93d8e",
  null
  
)

export default component.exports